// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-list-item--link[data-v-ff4e9e16]::before {\n  background-color: red;\n}\n.theme--light.v-list-item[data-v-ff4e9e16]:hover::before {\n  opacity: 0.64;\n}\n.pdfclass[data-v-ff4e9e16] {\n  background-color: white !important;\n}", ""]);
// Exports
module.exports = exports;
